import type { ReactNode } from 'react';
import { cn } from '../../utils';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

/**
 * Generic empty-state card. Used inside DataTable and standalone.
 * Monochrome-first; any icon color inherits `currentColor`.
 */
export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 px-6 py-12 text-center',
        'text-[var(--color-text-secondary)]',
        className,
      )}
    >
      {icon ? (
        <div className="text-[var(--color-text-tertiary)] [&_svg]:size-10" aria-hidden>
          {icon}
        </div>
      ) : null}
      <div className="space-y-1">
        <p className="text-[15px] font-medium text-[var(--color-text-primary)]">{title}</p>
        {description ? (
          <p className="max-w-[420px] text-[13px] text-[var(--color-text-secondary)]">
            {description}
          </p>
        ) : null}
      </div>
      {action ? <div className="pt-1">{action}</div> : null}
    </div>
  );
}
